import { size } from "polished";
import styled from "styled-components";
import ArrowLeftIcon from "../../img/icons/arrow-left.svg?react";
import ArrowRightIcon from "../../img/icons/arrow-right.svg?react";
import ArrowLeftDoubleIcon from "../../img/icons/arrow-double-left.svg?react";
import ArrowRightDoubleIcon from "../../img/icons/arrow-double-right.svg?react";

interface IArrow {
  color?: "black";
}

export const ArrowLeft = styled(ArrowLeftIcon)<IArrow>`
  fill: ${(props) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ArrowRight = styled(ArrowRightIcon)<IArrow>`
  fill: ${(props) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ArrowLeftDouble = styled(ArrowLeftDoubleIcon)<IArrow>`
  fill: ${(props) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ArrowRightDouble = styled(ArrowRightDoubleIcon)<IArrow>`
  fill: ${(props) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ControlArrowRight = styled(ArrowRight)`
  ${size("16px")};
  margin-left: 0.5rem;
  vertical-align: middle;
`;

export const ControlArrowLeft = styled(ArrowLeft)`
  ${size("16px")};
  margin-right: 0.5rem;
  vertical-align: middle;
`;
